import { MessageCircle } from "lucide-react";
import { BRAND, UI } from "@/content";
import { useLang } from "@/LangContext";

export default function FloatingBar() {
  const { lang } = useLang();

  return (
    <>
      <div
        className="fixed bottom-0 inset-x-0 z-40 md:hidden flex border-t border-gold/25 bg-forest/95 backdrop-blur-xl"
        data-testid="mobile-booking-bar"
      >
        <a
          href={BRAND.fresha}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-book-fresha"
          className="flex-1 flex items-center justify-center gap-2 bg-gold text-forest font-medium text-sm py-4"
        >
          {lang === "es" ? "Reservar en Fresha" : "Book on Fresha"}
        </a>
        <a
          href={BRAND.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-whatsapp-button"
          className="flex-1 flex items-center justify-center gap-2 text-wamist font-medium text-sm py-4"
        >
          <MessageCircle className="w-4 h-4" />
          WhatsApp
        </a>
      </div>

      <a
        href={BRAND.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-float-button"
        aria-label="WhatsApp"
        className="hidden md:flex fixed bottom-7 right-7 z-40 w-14 h-14 items-center justify-center rounded-full bg-wamist text-forest shadow-[0_12px_36px_rgba(37,211,102,0.35)] hover:scale-110 active:scale-95 transition-transform duration-300"
      >
        <MessageCircle className="w-6 h-6" />
      </a>
    </>
  );
}
